const spacing = {
  spacingXS: '4px',
  spacingS: '8px',
  spacingM: '32px',
};

export default spacing;
